import { useAtom } from "@reatom/npm-react"
import { Link } from "react-router-dom"

import { Spinner } from "components/Spinner"
import {
    AdvancedFilters,
    BasicFilters,
    FiltersAction,
    PromotedPsys,
} from "modules/PsyCatalog/common"
import { Footer, Layout, PageHeaderWithHero } from "components"
import { loadingAtom } from "modules/PsyCatalog/common/models/searchRequest"
import { pageMetaAtom } from "modules/PsyCatalog/common/models/pageMeta"
import { FieldStatus } from "modules/PsyCatalog/common/services/FieldStatus"
import { SEOText } from "modules/PsyCatalog/common/SEOText"
import "modules/PsyCatalog/common/models/initialSearch"
import { PsySearchResults } from "modules/PsyCatalog/browser-side/PsySearchResults"
import { Banner } from "modules/PsyCatalog/browser-side/ManualSelection/Banner"

export function PsyCatalogPage() {
    const [loadingStatus] = useAtom(loadingAtom)
    const [isDataReady] = useAtom(FieldStatus.readyAtom)

    const [pageMeta] = useAtom(pageMetaAtom)

    return (
        <Layout className="search-results">
            <PageHeaderWithHero title={pageMeta.h1}>
                <SEOText />
            </PageHeaderWithHero>
            <div className="b-container search-results__container">
                <section className="filters">
                    <form action="#" autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                        <BasicFilters />
                        <AdvancedFilters />
                        <FiltersAction />
                        {loadingStatus !== "loading" && (
                            <div className="alert alert-info text-center" role="alert">
                                {loadingStatus === "empty" &&
                                    "К сожалению, по вашему запросу ничего не найдено. Задайте другие критерии поиска."}
                            </div>
                        )}
                    </form>
                </section>
            </div>
            {isDataReady && <PromotedPsys />}
            <div className="b-container search-results__container">
                {Banner.canBeShown() && loadingStatus === "success" && <Banner />}
                {(loadingStatus === "loading" || !isDataReady) && <Spinner />}
                {loadingStatus === "error" && (
                    <div className="alert py-3 px-4 text-center alert-danger">
                        <p>Что-то пошло не так</p>
                        <p className="mb-0">
                            Но вы можете перейти на{" "}
                            <Link
                                to="/survey/psy"
                                className="alert-link"
                                style={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                }}
                            >
                                главную страницу
                            </Link>
                            , заполнить анкету и записаться к понравившемуся психологу.
                        </p>
                    </div>
                )}
                {loadingStatus === "success" && (
                    <div>
                        <PsySearchResults />
                    </div>
                )}
            </div>
            <Footer />
        </Layout>
    )
}
